module.exports = __webpack_public_path__ + "img/drag.165bfa35.gif";